export default __webpack_public_path__ + "static/media/clp.5a324400.mp3";